'use strict';

(function () {
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  /* ── Format Money ── */
  function money(cents) {
    return 'EGP ' + (cents / 100).toLocaleString('en-EG', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  /* ── Overlay ── */
  const overlay = $('#overlay');
  function showOverlay() { overlay.classList.add('is-visible'); document.body.style.overflow = 'hidden'; }
  function hideOverlay() { overlay.classList.remove('is-visible'); document.body.style.overflow = ''; }

  overlay && overlay.addEventListener('click', function (e) {
    if (e.target !== overlay) return; /* CRITICAL: never block child clicks */
    closeCart();
    closeMobileMenu();
    hideOverlay();
  });

  /* ── Header ── */
  function initHeader() {
    const header = $('.site-header');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Cart Drawer ── */
  const cartDrawer = $('.cart-drawer');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    showOverlay();
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    hideOverlay();
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      /* update badge */
      $$('.cart-badge').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      /* update total */
      const totalEl = $('.cart-total-price');
      if (totalEl) totalEl.textContent = money(cart.total_price);

      /* update body */
      const body = $('.cart-drawer__body');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        return;
      }

      body.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <a href="${item.url}">
            <img class="cart-item__img" src="${item.image}" alt="${item.title}" loading="lazy">
          </a>
          <div>
            <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
            <p class="cart-item__price">${money(item.line_price)}</p>
          </div>
        </div>
      `).join('');

    } catch (e) {
      console.warn('Cart refresh error:', e);
    }
  }

  /* ── Add To Cart ── */
  function initAddToCart() {
    const form = $('.product-form');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = form.querySelector('.btn-atc');
      if (!btn) return;

      const orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';

      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!res.ok) throw new Error('Add to cart failed');
        openCart();
      } catch (err) {
        console.error(err);
        btn.textContent = 'Error — try again';
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        return;
      }

      btn.textContent = orig;
      btn.disabled = false;
    });
  }

  /* ── Mobile Menu ── */
  const mobileNav = $('.mobile-nav');

  function openMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    showOverlay();
  }

  function closeMobileMenu() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (!cartDrawer?.classList.contains('is-open')) hideOverlay();
  }

  /* ── Variants ── */
  function initVariants() {
    $$('.size-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        if (this.classList.contains('is-unavailable')) return;
        const group = this.closest('.size-btns');
        $$('.size-btn', group).forEach(b => b.classList.remove('is-selected'));
        this.classList.add('is-selected');

        const hiddenId = $('input[name="id"]');
        if (hiddenId && this.dataset.variantId) hiddenId.value = this.dataset.variantId;

        const atcBtn = $('.btn-atc');
        if (atcBtn) {
          const avail = this.dataset.available !== 'false';
          atcBtn.disabled = !avail;
          atcBtn.textContent = avail ? 'Add to Cart' : 'Sold Out';
        }
      });
    });
  }

  /* ── Product Gallery ── */
  function initGallery() {
    const mainImg = $('#main-product-img');
    $$('.product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', function () {
        $$('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        if (mainImg && this.dataset.src) { mainImg.src = this.dataset.src; }
      });
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initAddToCart();
    initVariants();
    initGallery();

    /* Cart triggers */
    $$('[data-open-cart]').forEach(btn => btn.addEventListener('click', openCart));
    const closeBtn = $('.cart-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);

    /* Mobile menu */
    const menuBtn = $('.mobile-menu-btn');
    if (menuBtn) menuBtn.addEventListener('click', openMobileMenu);
    const closeMenu = $('.mobile-nav-close');
    if (closeMenu) closeMenu.addEventListener('click', closeMobileMenu);
  });

})();
